module.exports = __webpack_public_path__ + "img/skip-start-circle-fill.98ee3a07.svg";